(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/extensions/ball-row-wininfo-joker.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/extensions/ball-row-wininfo-joker.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.extensions = svs.tur.ball.row.extensions || {};
class WinInfoJoker extends svs.tur.Base {
  constructor(row) {
    super({
      className: 'ball-row-wininfo-joker'
    });
    this.$ahead = document.createElement('span');
    this.$ahead.className = 'ball-row-wininfo-ahead';
    this.$reverse = document.createElement('span');
    this.$reverse.className = 'ball-row-wininfo-reverse';
    this.$el.appendChild(this.$ahead);
    this.$el.appendChild(this.$reverse);
    this.row = row;
    this.row.$el.appendChild(this.$el);
    this.reset();
  }
  render() {
    return this.$el;
  }
  set() {
    this.$ahead.innerText = "".concat(this.ahead, " r\xE4tt framifr\xE5n");
    this.$reverse.innerText = "".concat(this.reverse, " r\xE4tt bakifr\xE5n");
  }
  reset() {
    this.correctedRow = {};
    this.ahead = 0;
    this.reverse = 0;
    this.correctNumbers = 0;
    this.set();
  }
  add() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        index: undefined
      },
      isCorrect = _ref.isCorrect,
      index = _ref.index;
    if (typeof index === 'undefined') return;
    if (Object.prototype.hasOwnProperty.call(this.correctedRow, index)) return;
    this.correctedRow[index] = isCorrect;
    this.calculateCorrect();
  }
  calculateCorrect() {
    let correctedRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.correctedRow;
    const boolArray = Object.values(correctedRow);
    this.ahead = 0;
    for (let i = 0; i < boolArray.length; i++) {
      if (!boolArray[i]) {
        break;
      }
      this.ahead += 1;
    }
    if (boolArray.length === 7) {
      let i = boolArray.length;
      this.reverse = 0;
      while (i--) {
        if (!boolArray[i]) {
          break;
        }
        this.reverse += 1;
      }
    }
    this.correctNumbers = Math.max(this.ahead, this.reverse);
    this.set();
  }
}
svs.tur.ball.row.extensions.WinInfoJoker = WinInfoJoker;

 })(window);